import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter, FaLinkedin } from 'react-icons/fa';

const iconStyle = (Icon) => <Icon />;

export const footerSocialData = [
	{
		name: 'Facebook',
		icon: iconStyle(FaFacebook),
	},
	{
		name: 'Instagram',
		icon: iconStyle(FaInstagram),
	},
	{
		name: 'YouTube',
		icon: iconStyle(FaYoutube),
	},
	{
		name: 'Twitter',
		icon: iconStyle(FaTwitter),
	},
	{
		name: 'LinkedIn',
		icon: iconStyle(FaLinkedin),
	},
];

export const footerData = [
	{
		title: 'Communication',
		links: [],
	},
	{
		title: 'Finance management',
		links: [],
	},
	{
		title: 'Marketing',
		links: [],
	},
	{
		title: 'Software',
		links: [],
	},
	{
		title: 'Cyber Security',
		links: [],
	},
	{
		title: 'Legal assistance',
		links: [],
	},
	{
		title: 'Business strategy',
		links: [],
	},
	{
		title: 'Human ressource',
		links: [],
	},
	{
		title: 'Cloud',
		links: [],
	},
	{
		title: 'Devops',
		links: [],
	},
	{
		title: 'Database management',
		links: [],
	}
];
